import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-table__row" }
const _hoisted_2 = { class: "gfu-table__cell gfu-table__cell-row _flexb50 _flexb75--s _flexb60--m _flexb60--xl _pa-0" }
const _hoisted_3 = { class: "_screen--none _screen--s" }
const _hoisted_4 = { class: "gfu-table__cell--image _mr-3 _fl" }
const _hoisted_5 = { class: "gfu-table__thumb" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "gfu-table__cell--grow _pt-1 _pb-1" }
const _hoisted_8 = { class: "_flexcol _ai-fs" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  "data-qa": "cart-table:ProductOptionValue"
}
const _hoisted_12 = {
  class: "gfu-table__cell gfu-table__cell--actions _tac _flexb15 _flexb10--s _flexcntr",
  "data-qa": "cart-table:ProductQuantity"
}
const _hoisted_13 = {
  key: 0,
  class: "gfu-product__amount gfu-1of1"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  class: "gfu-table__cell _tar _flexb35 _flexb25--s _flexb15--m",
  "data-text": "Total price"
}
const _hoisted_18 = { "data-qa": "cart-table:ProductPrice" }
const _hoisted_19 = {
  key: 0,
  class: "gfu-bt--overline _tc--light",
  "data-qa": "cart-table:ProductTax"
}
const _hoisted_20 = {
  key: 0,
  class: "gfu-table__cell _tar _pa-0 _flexb5 _screen--none _screen--s"
}
const _hoisted_21 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_product_option_field = _resolveComponent("product-option-field")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_number_field = _resolveComponent("number-field")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: $options.itemDetailsRoute,
            onClick: $options.onItemDetailsClick
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: _ctx.item.product.imageUrl,
                  alt: _ctx.item.displayName
                }, null, 8 /* PROPS */, _hoisted_6)
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to", "onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: $options.itemDetailsRoute,
            class: "gfu-table__text--strong gfu-table__text--big",
            onClick: $options.onItemDetailsClick,
            "data-qa": "cart-table:ProductName"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.item.displayName), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to", "onClick"]),
          (_ctx.canDelete)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                disabled: _ctx.isProcessing,
                class: "_pl-0 _mt-0 _tc--error _screen--not-s",
                onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.setOrderItemQuantity(0, _ctx.item)), ["prevent"]))
              }, _toDisplayString(_ctx.Resources.Checkout.RemoveItemButton), 9 /* TEXT, PROPS */, _hoisted_9))
            : _createCommentVNode("v-if", true)
        ]),
        (_ctx.canEditOption)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.product.options.filter(o => o.values.length > 0), (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'product-option-' + option.productOptionID,
                  "data-qa": "cart-table:ProductOptions"
                }, [
                  _createVNode(_component_product_option_field, {
                    ref_for: true,
                    ref: 'option-' + _ctx.item.orderItemID + '-' + option.productOptionID,
                    "label-class": "gfu-field__label--light",
                    "field-class": "gfu-field-select--tiny-text gfu-field-select--squeezed gfu-5of6 gfu-2of3--m",
                    option: option,
                    "selected-option-value-id": _ctx.getProductOptionValueID(_ctx.item.options, option.productOptionID),
                    "order-item-id": _ctx.item.orderItemID,
                    onChange: _ctx.setOrderItemOption
                  }, null, 8 /* PROPS */, ["option", "selected-option-value-id", "order-item-id", "onChange"])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : (_ctx.item.product.options.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($options.getReadonlyProductOptionValuesList(_ctx.item)), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.canEditQuantity)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "gfu-table__amount-btn gfu-table__amount-btn--plus gfu-btn gfu-btn--icon gfu-btn--primary",
              type: "button",
              disabled: _ctx.isProcessing,
              onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.setOrderItemQuantityPreventingZero(_ctx.item.quantity + 1, _ctx.item)), ["prevent"])),
              "data-qa": "begin-order-form-button:Plus"
            }, [
              _createVNode(_component_base_icon, { name: "plus" })
            ], 8 /* PROPS */, _hoisted_14),
            _createElementVNode("button", {
              class: "gfu-table__amount-btn gfu-table__amount-btn--minus gfu-btn gfu-btn--icon gfu-btn--primary",
              type: "button",
              disabled: _ctx.isProcessing,
              onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($options.setOrderItemQuantityPreventingZero(_ctx.item.quantity - 1, _ctx.item)), ["prevent"])),
              "data-qa": "begin-order-form-button:Minus"
            }, [
              _createVNode(_component_base_icon, { name: "minus" })
            ], 8 /* PROPS */, _hoisted_15),
            _createVNode(_component_number_field, {
              modelValue: _ctx.item.quantity,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.item.quantity) = $event)),
              class: _normalizeClass({'has-error': $options.isItemRestricted}),
              name: "totalQuantity",
              "show-label": false,
              integer: true,
              min: 1,
              max: _ctx.maxQuantity,
              maxlength: $data.maxQuantityDigits,
              negative: false,
              "validator-layout": "none",
              disabled: _ctx.isProcessing,
              onFocusout: _cache[4] || (_cache[4] = $event => (_ctx.setOrderItemQuantity(_ctx.item.quantity, _ctx.item))),
              onEnter: _cache[5] || (_cache[5] = _withModifiers($event => (_ctx.setOrderItemQuantity(_ctx.item.quantity, _ctx.item)), ["prevent"])),
              "data-qa": "begin-order-form-counter:Quantity"
            }, null, 8 /* PROPS */, ["modelValue", "class", "max", "maxlength", "disabled"]),
            ($options.showWarning)
              ? (_openBlock(), _createBlock(_component_tooltip, {
                  key: 0,
                  class: "gfu-table__amount-error-wrapper",
                  text: $options.tooltipMessage,
                  "data-qa": "quantity-error-warning-icon-tooltip"
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("span", {
                      class: "gfu-table__amount-error",
                      "data-qa": "cart-table-item-row-quantity-error:WarningIcon"
                    }, null, -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["text"]))
              : _createCommentVNode("v-if", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("span", null, _toDisplayString(_ctx.item.quantity), 1 /* TEXT */),
            ($options.showWarning)
              ? (_openBlock(), _createBlock(_component_tooltip, {
                  key: 0,
                  class: "gfu-table__amount-error-wrapper",
                  text: $options.tooltipMessage,
                  "data-qa": "quantity-error-warning-icon-tooltip"
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("span", {
                      class: "gfu-table__amount-error",
                      "data-qa": "cart-table-item-row-quantity-error:WarningIcon"
                    }, null, -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["text"]))
              : _createCommentVNode("v-if", true)
          ]))
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.priceFormatted), 1 /* TEXT */),
      (_ctx.showTaxValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.taxFormatted), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.allowEditing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          (_ctx.canDelete)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "gfu-btn gfu-btn--icon",
                disabled: _ctx.isProcessing,
                onClick: _cache[6] || (_cache[6] = _withModifiers($event => (_ctx.setOrderItemQuantity(0, _ctx.item)), ["prevent"]))
              }, [
                _createVNode(_component_base_icon, {
                  name: "times-circle",
                  class: "_tc--error",
                  "data-qa": "begin-order-form-button:RemoveItem"
                })
              ], 8 /* PROPS */, _hoisted_21))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}